const ADD_CHART_PLACEHOLDER =
  'Show me a split of revenue per city per payment method used';

const CHART_CREATION =
  'Select only one column for KPI and upto 2 columns for a chart.';

const CUSTOMISE_CHART =
  'You can customize it and make changes in the next step.';

const GO_AUTO = "Don't know what you are looking for? Try Auto AI.";

const GO_AUTO_DESCRIPTION =
  'Our AI engine will create optimal charts for you based on your data.';

const ADD_CHART_TOOLTIP =
  'Create a chart yourself on this page. Select one or two columns from the imported data';

const CHART_COMBINATION_ERROR =
  'Sorry, we do not support this combination at the moment. However, you can select any one Numeric data column and proceed.';

const ERROR = 'Something went wrong';

const CHART_SUCCESSFULLY_CREATED = 'Chart created successfully, Redirecting...';

const KPI_SUCCESSFULLY_CREATED = 'KPI created successfully, Redirecting...';

const INVALID_BOT_INPUT =
  'Looks like we could not create a chart based on this input. We recommend you to try again by using similar column names as in your imported data';

const CHART_DATA_PROCESSING = 'Chart data not found. Processing.';

const ERROR_STATUS_500 =
  'Sorry, we could not process your input. Please try later.';

const NO_DATA_MODIFICATIONS_AFTER_REFRESH =
  'There has been no modifications in the datasource since the last update';

const GOOGLE_SHEET_PERMISSION_DENIED =
  'Our system is unable to access your data. This may be because the “Share” setting of this Google Sheet is Restricted. Please change it to “Anyone with the link” and try again.';

const INVALID_GOOGLE_SHEET =
  'Our system is unable to access your data. This may be because there is no associated Google Sheet with the link/ID you provided. Please ensure that the link/ID you entered is valid and active, and try again.';

const GOOGLE_SHEET_UNKNOWN_ISSUE_OCCURRED =
  'Sorry, we encountered an unexpected issue. Please try again later. If the problem persists, please contact support for assistance.';

const NON_GOOGLE_SHEET_RESOURCE_URL =
  'We do not support Google Slides, Docs, Forms or G-drive links. Please enter a valid Google Sheet link or Spreadsheet ID.';

const INVALID_URL_OR_SPREADSHEET_ID = `This doesn't appear to be a valid Google Sheet link or  Spreadsheet ID. Please enter the right URL.`;

const INSIGHT_CREATION_FAILED = 'Project insights creation unsuccessful.';

const GSHEET_UPDATE_INITIATED = 'Cloud Update Task Initiated';

export {
  ADD_CHART_PLACEHOLDER,
  CHART_CREATION,
  CUSTOMISE_CHART,
  GO_AUTO,
  GO_AUTO_DESCRIPTION,
  ADD_CHART_TOOLTIP,
  CHART_COMBINATION_ERROR,
  ERROR,
  CHART_SUCCESSFULLY_CREATED,
  KPI_SUCCESSFULLY_CREATED,
  INVALID_BOT_INPUT,
  CHART_DATA_PROCESSING,
  ERROR_STATUS_500,
  NO_DATA_MODIFICATIONS_AFTER_REFRESH,
  GOOGLE_SHEET_PERMISSION_DENIED,
  INVALID_GOOGLE_SHEET,
  GOOGLE_SHEET_UNKNOWN_ISSUE_OCCURRED,
  NON_GOOGLE_SHEET_RESOURCE_URL,
  INVALID_URL_OR_SPREADSHEET_ID,
  INSIGHT_CREATION_FAILED,
  GSHEET_UPDATE_INITIATED
};
